import { Stack } from "@mui/material";
import { ProductionEstimator } from "./productionEstimator";
import { CopyProductionButton, PasteProductionButton } from "./copyPaste";
import { usePeriodIndex } from "hooks/periodIndex";
import { useEstimateProduction } from "contexts/search/wizards/estimateProduction";
import {
  SearchProductGroups,
  SearchSteelGrades,
} from "contexts/search/context";
import { ProductionWizard } from "./wizard";
import { useProductionPlan } from "hooks/search";
import { ProductionPlan } from "models/ProductionPlan";

export const ToolsPanel = ({
  productionPlan,
  productGroups,
  steelGrades,
}: {
  productionPlan: ProductionPlan;
  productGroups: SearchProductGroups;
  steelGrades: SearchSteelGrades;
}) => {
  const periodTab = usePeriodIndex();

  const [, setProductionPlan] = useProductionPlan(periodTab);
  const estimate = useEstimateProduction(setProductionPlan);

  return (
    <Stack spacing={2}>
      <ProductionWizard period={periodTab} />
      <ProductionEstimator
        estimate={estimate}
        inputMode={
          productionPlan.type === "steelGrade" ? "steelGrades" : "productGroups"
        }
      />
      <Stack direction="row" gap={1}>
        <CopyProductionButton
          productionPlan={productionPlan}
          productGroups={productGroups}
          steelGrades={steelGrades}
        />
        <PasteProductionButton
          setProductionPlan={setProductionPlan}
          productGroups={productGroups}
          steelGrades={steelGrades}
        />
      </Stack>
    </Stack>
  );
};
